import { $replaceRoot } from "./replaceRoot";
const $replaceWith = $replaceRoot;
export {
  $replaceWith
};
